import { default as _91token_93dPInuQZZ5pMeta } from "/shared/home/frontend/deployr/releases/20250507100418/packages/intermediairs/pages/activeer-account/[token].vue?macro=true";
import { default as indexOapr3iCvYkMeta } from "/shared/home/frontend/deployr/releases/20250507100418/packages/intermediairs/pages/index.vue?macro=true";
import { default as indexOmzD6gJZIiMeta } from "/shared/home/frontend/deployr/releases/20250507100418/packages/intermediairs/pages/login/index.vue?macro=true";
import { default as reset_45wachtwoordrWRW6rrsvCMeta } from "/shared/home/frontend/deployr/releases/20250507100418/packages/intermediairs/pages/login/reset-wachtwoord.vue?macro=true";
import { default as wachtwoord_45vergetenkdtbVihl8fMeta } from "/shared/home/frontend/deployr/releases/20250507100418/packages/intermediairs/pages/login/wachtwoord-vergeten.vue?macro=true";
import { default as _91mail_93GnfZvv3HW7Meta } from "/shared/home/frontend/deployr/releases/20250507100418/packages/intermediairs/pages/mijn-aanvragen/[id]/[mail].vue?macro=true";
import { default as berichtenboxDDJZYRSfXBMeta } from "/shared/home/frontend/deployr/releases/20250507100418/packages/intermediairs/pages/mijn-aanvragen/[id]/berichtenbox.vue?macro=true";
import { default as indexLHshg5ED6jMeta } from "/shared/home/frontend/deployr/releases/20250507100418/packages/intermediairs/pages/mijn-aanvragen/[id]/documenten/index.vue?macro=true";
import { default as indexttx8GiQJaSMeta } from "/shared/home/frontend/deployr/releases/20250507100418/packages/intermediairs/pages/mijn-aanvragen/[id]/index.vue?macro=true";
import { default as _91uuid_93gt1n0gQ8brMeta } from "/shared/home/frontend/deployr/releases/20250507100418/packages/intermediairs/pages/mijn-aanvragen/[id]/offerte-aanvragen/[uuid].vue?macro=true";
import { default as indexh0Oxt5poCrMeta } from "/shared/home/frontend/deployr/releases/20250507100418/packages/intermediairs/pages/mijn-profiel/index.vue?macro=true";
import { default as indexZwfOQS1rUjMeta } from "/shared/home/frontend/deployr/releases/20250507100418/packages/intermediairs/pages/onboarding/index.vue?macro=true";
import { default as indexiAnuuuZcpRMeta } from "/shared/home/frontend/deployr/releases/20250507100418/packages/intermediairs/pages/portefeuille-aanvraag/index.vue?macro=true";
import { default as index7C7LUzaTw1Meta } from "/shared/home/frontend/deployr/releases/20250507100418/packages/intermediairs/pages/properties/index.vue?macro=true";
import { default as indexXYe213dfRTMeta } from "/shared/home/frontend/deployr/releases/20250507100418/packages/intermediairs/pages/quickscan/index.vue?macro=true";
import { default as _91token_93GtH6kkshpTMeta } from "/shared/home/frontend/deployr/releases/20250507100418/packages/intermediairs/pages/sso/[token].vue?macro=true";
import { default as _91hash_93EIdFnLxQY4Meta } from "/shared/home/frontend/deployr/releases/20250507100418/packages/intermediairs/pages/vragen/[hash].vue?macro=true";
import { default as homenwhKVchDrhMeta } from "/shared/home/frontend/deployr/releases/20250507100418/packages/layers/intake/pages/home.vue?macro=true";
import { default as adresLDgni8JGf7Meta } from "/shared/home/frontend/deployr/releases/20250507100418/packages/layers/intake/pages/intake/[id]/adres.vue?macro=true";
import { default as afgerondLjoPq4czA5Meta } from "/shared/home/frontend/deployr/releases/20250507100418/packages/layers/intake/pages/intake/[id]/afgerond.vue?macro=true";
import { default as beslisboomJLRn4nd5y9Meta } from "/shared/home/frontend/deployr/releases/20250507100418/packages/layers/intake/pages/intake/[id]/beslisboom.vue?macro=true";
import { default as dashboardx3xF8IcrQcMeta } from "/shared/home/frontend/deployr/releases/20250507100418/packages/layers/intake/pages/intake/[id]/dashboard.vue?macro=true";
import { default as financieringoafurj7jIkMeta } from "/shared/home/frontend/deployr/releases/20250507100418/packages/layers/intake/pages/intake/[id]/financiering.vue?macro=true";
import { default as geldnemerstjU2dwGtpvMeta } from "/shared/home/frontend/deployr/releases/20250507100418/packages/layers/intake/pages/intake/[id]/geldnemers.vue?macro=true";
import { default as identificatieZoOokJOUpeMeta } from "/shared/home/frontend/deployr/releases/20250507100418/packages/layers/intake/pages/intake/[id]/identificatie.vue?macro=true";
import { default as indexVJWnDeYWowMeta } from "/shared/home/frontend/deployr/releases/20250507100418/packages/layers/intake/pages/intake/[id]/index.vue?macro=true";
import { default as object8u8DVIbivoMeta } from "/shared/home/frontend/deployr/releases/20250507100418/packages/layers/intake/pages/intake/[id]/object.vue?macro=true";
import { default as ondertekenenxM6Y54YxMiMeta } from "/shared/home/frontend/deployr/releases/20250507100418/packages/layers/intake/pages/intake/[id]/ondertekenen.vue?macro=true";
import { default as overigRNjh9o0wf3Meta } from "/shared/home/frontend/deployr/releases/20250507100418/packages/layers/intake/pages/intake/[id]/overig.vue?macro=true";
import { default as verklaringenRLZPjGZLOeMeta } from "/shared/home/frontend/deployr/releases/20250507100418/packages/layers/intake/pages/intake/[id]/verklaringen.vue?macro=true";
export default [
  {
    name: _91token_93dPInuQZZ5pMeta?.name ?? "activeer-account-token",
    path: _91token_93dPInuQZZ5pMeta?.path ?? "/activeer-account/:token()",
    meta: _91token_93dPInuQZZ5pMeta || {},
    alias: _91token_93dPInuQZZ5pMeta?.alias || [],
    redirect: _91token_93dPInuQZZ5pMeta?.redirect || undefined,
    component: () => import("/shared/home/frontend/deployr/releases/20250507100418/packages/intermediairs/pages/activeer-account/[token].vue").then(m => m.default || m)
  },
  {
    name: indexOapr3iCvYkMeta?.name ?? "index",
    path: indexOapr3iCvYkMeta?.path ?? "/",
    meta: indexOapr3iCvYkMeta || {},
    alias: indexOapr3iCvYkMeta?.alias || [],
    redirect: indexOapr3iCvYkMeta?.redirect || undefined,
    component: () => import("/shared/home/frontend/deployr/releases/20250507100418/packages/intermediairs/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexOmzD6gJZIiMeta?.name ?? "login",
    path: indexOmzD6gJZIiMeta?.path ?? "/login",
    meta: indexOmzD6gJZIiMeta || {},
    alias: indexOmzD6gJZIiMeta?.alias || [],
    redirect: indexOmzD6gJZIiMeta?.redirect || undefined,
    component: () => import("/shared/home/frontend/deployr/releases/20250507100418/packages/intermediairs/pages/login/index.vue").then(m => m.default || m)
  },
  {
    name: reset_45wachtwoordrWRW6rrsvCMeta?.name ?? "login-reset-wachtwoord",
    path: reset_45wachtwoordrWRW6rrsvCMeta?.path ?? "/login/reset-wachtwoord",
    meta: reset_45wachtwoordrWRW6rrsvCMeta || {},
    alias: reset_45wachtwoordrWRW6rrsvCMeta?.alias || [],
    redirect: reset_45wachtwoordrWRW6rrsvCMeta?.redirect || undefined,
    component: () => import("/shared/home/frontend/deployr/releases/20250507100418/packages/intermediairs/pages/login/reset-wachtwoord.vue").then(m => m.default || m)
  },
  {
    name: wachtwoord_45vergetenkdtbVihl8fMeta?.name ?? "login-wachtwoord-vergeten",
    path: wachtwoord_45vergetenkdtbVihl8fMeta?.path ?? "/login/wachtwoord-vergeten",
    meta: wachtwoord_45vergetenkdtbVihl8fMeta || {},
    alias: wachtwoord_45vergetenkdtbVihl8fMeta?.alias || [],
    redirect: wachtwoord_45vergetenkdtbVihl8fMeta?.redirect || undefined,
    component: () => import("/shared/home/frontend/deployr/releases/20250507100418/packages/intermediairs/pages/login/wachtwoord-vergeten.vue").then(m => m.default || m)
  },
  {
    name: _91mail_93GnfZvv3HW7Meta?.name ?? "mijn-aanvragen-id-mail",
    path: _91mail_93GnfZvv3HW7Meta?.path ?? "/mijn-aanvragen/:id()/:mail()",
    meta: _91mail_93GnfZvv3HW7Meta || {},
    alias: _91mail_93GnfZvv3HW7Meta?.alias || [],
    redirect: _91mail_93GnfZvv3HW7Meta?.redirect || undefined,
    component: () => import("/shared/home/frontend/deployr/releases/20250507100418/packages/intermediairs/pages/mijn-aanvragen/[id]/[mail].vue").then(m => m.default || m)
  },
  {
    name: berichtenboxDDJZYRSfXBMeta?.name ?? "mijn-aanvragen-id-berichtenbox",
    path: berichtenboxDDJZYRSfXBMeta?.path ?? "/mijn-aanvragen/:id()/berichtenbox",
    meta: berichtenboxDDJZYRSfXBMeta || {},
    alias: berichtenboxDDJZYRSfXBMeta?.alias || [],
    redirect: berichtenboxDDJZYRSfXBMeta?.redirect || undefined,
    component: () => import("/shared/home/frontend/deployr/releases/20250507100418/packages/intermediairs/pages/mijn-aanvragen/[id]/berichtenbox.vue").then(m => m.default || m)
  },
  {
    name: indexLHshg5ED6jMeta?.name ?? "mijn-aanvragen-id-documenten",
    path: indexLHshg5ED6jMeta?.path ?? "/mijn-aanvragen/:id()/documenten",
    meta: indexLHshg5ED6jMeta || {},
    alias: indexLHshg5ED6jMeta?.alias || [],
    redirect: indexLHshg5ED6jMeta?.redirect || undefined,
    component: () => import("/shared/home/frontend/deployr/releases/20250507100418/packages/intermediairs/pages/mijn-aanvragen/[id]/documenten/index.vue").then(m => m.default || m)
  },
  {
    name: indexttx8GiQJaSMeta?.name ?? "mijn-aanvragen-id",
    path: indexttx8GiQJaSMeta?.path ?? "/mijn-aanvragen/:id()",
    meta: indexttx8GiQJaSMeta || {},
    alias: indexttx8GiQJaSMeta?.alias || [],
    redirect: indexttx8GiQJaSMeta?.redirect || undefined,
    component: () => import("/shared/home/frontend/deployr/releases/20250507100418/packages/intermediairs/pages/mijn-aanvragen/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93gt1n0gQ8brMeta?.name ?? "mijn-aanvragen-id-offerte-aanvragen-uuid",
    path: _91uuid_93gt1n0gQ8brMeta?.path ?? "/mijn-aanvragen/:id()/offerte-aanvragen/:uuid()",
    meta: _91uuid_93gt1n0gQ8brMeta || {},
    alias: _91uuid_93gt1n0gQ8brMeta?.alias || [],
    redirect: _91uuid_93gt1n0gQ8brMeta?.redirect || undefined,
    component: () => import("/shared/home/frontend/deployr/releases/20250507100418/packages/intermediairs/pages/mijn-aanvragen/[id]/offerte-aanvragen/[uuid].vue").then(m => m.default || m)
  },
  {
    name: indexh0Oxt5poCrMeta?.name ?? "mijn-profiel",
    path: indexh0Oxt5poCrMeta?.path ?? "/mijn-profiel",
    meta: indexh0Oxt5poCrMeta || {},
    alias: indexh0Oxt5poCrMeta?.alias || [],
    redirect: indexh0Oxt5poCrMeta?.redirect || undefined,
    component: () => import("/shared/home/frontend/deployr/releases/20250507100418/packages/intermediairs/pages/mijn-profiel/index.vue").then(m => m.default || m)
  },
  {
    name: indexZwfOQS1rUjMeta?.name ?? "onboarding",
    path: indexZwfOQS1rUjMeta?.path ?? "/onboarding",
    meta: indexZwfOQS1rUjMeta || {},
    alias: indexZwfOQS1rUjMeta?.alias || [],
    redirect: indexZwfOQS1rUjMeta?.redirect || undefined,
    component: () => import("/shared/home/frontend/deployr/releases/20250507100418/packages/intermediairs/pages/onboarding/index.vue").then(m => m.default || m)
  },
  {
    name: indexiAnuuuZcpRMeta?.name ?? "portefeuille-aanvraag",
    path: indexiAnuuuZcpRMeta?.path ?? "/portefeuille-aanvraag",
    meta: indexiAnuuuZcpRMeta || {},
    alias: indexiAnuuuZcpRMeta?.alias || [],
    redirect: indexiAnuuuZcpRMeta?.redirect || undefined,
    component: () => import("/shared/home/frontend/deployr/releases/20250507100418/packages/intermediairs/pages/portefeuille-aanvraag/index.vue").then(m => m.default || m)
  },
  {
    name: index7C7LUzaTw1Meta?.name ?? "properties",
    path: index7C7LUzaTw1Meta?.path ?? "/properties",
    meta: index7C7LUzaTw1Meta || {},
    alias: index7C7LUzaTw1Meta?.alias || [],
    redirect: index7C7LUzaTw1Meta?.redirect || undefined,
    component: () => import("/shared/home/frontend/deployr/releases/20250507100418/packages/intermediairs/pages/properties/index.vue").then(m => m.default || m)
  },
  {
    name: indexXYe213dfRTMeta?.name ?? "quickscan",
    path: indexXYe213dfRTMeta?.path ?? "/quickscan",
    meta: indexXYe213dfRTMeta || {},
    alias: indexXYe213dfRTMeta?.alias || [],
    redirect: indexXYe213dfRTMeta?.redirect || undefined,
    component: () => import("/shared/home/frontend/deployr/releases/20250507100418/packages/intermediairs/pages/quickscan/index.vue").then(m => m.default || m)
  },
  {
    name: _91token_93GtH6kkshpTMeta?.name ?? "sso-token",
    path: _91token_93GtH6kkshpTMeta?.path ?? "/sso/:token()",
    meta: _91token_93GtH6kkshpTMeta || {},
    alias: _91token_93GtH6kkshpTMeta?.alias || [],
    redirect: _91token_93GtH6kkshpTMeta?.redirect || undefined,
    component: () => import("/shared/home/frontend/deployr/releases/20250507100418/packages/intermediairs/pages/sso/[token].vue").then(m => m.default || m)
  },
  {
    name: _91hash_93EIdFnLxQY4Meta?.name ?? "vragen-hash",
    path: _91hash_93EIdFnLxQY4Meta?.path ?? "/vragen/:hash()",
    meta: _91hash_93EIdFnLxQY4Meta || {},
    alias: _91hash_93EIdFnLxQY4Meta?.alias || [],
    redirect: _91hash_93EIdFnLxQY4Meta?.redirect || undefined,
    component: () => import("/shared/home/frontend/deployr/releases/20250507100418/packages/intermediairs/pages/vragen/[hash].vue").then(m => m.default || m)
  },
  {
    name: homenwhKVchDrhMeta?.name ?? "home",
    path: homenwhKVchDrhMeta?.path ?? "/home",
    meta: homenwhKVchDrhMeta || {},
    alias: homenwhKVchDrhMeta?.alias || [],
    redirect: homenwhKVchDrhMeta?.redirect || undefined,
    component: () => import("/shared/home/frontend/deployr/releases/20250507100418/packages/layers/intake/pages/home.vue").then(m => m.default || m)
  },
  {
    name: adresLDgni8JGf7Meta?.name ?? "intake-id-adres",
    path: adresLDgni8JGf7Meta?.path ?? "/intake/:id()/adres",
    meta: adresLDgni8JGf7Meta || {},
    alias: adresLDgni8JGf7Meta?.alias || [],
    redirect: adresLDgni8JGf7Meta?.redirect || undefined,
    component: () => import("/shared/home/frontend/deployr/releases/20250507100418/packages/layers/intake/pages/intake/[id]/adres.vue").then(m => m.default || m)
  },
  {
    name: afgerondLjoPq4czA5Meta?.name ?? "intake-id-afgerond",
    path: afgerondLjoPq4czA5Meta?.path ?? "/intake/:id()/afgerond",
    meta: afgerondLjoPq4czA5Meta || {},
    alias: afgerondLjoPq4czA5Meta?.alias || [],
    redirect: afgerondLjoPq4czA5Meta?.redirect || undefined,
    component: () => import("/shared/home/frontend/deployr/releases/20250507100418/packages/layers/intake/pages/intake/[id]/afgerond.vue").then(m => m.default || m)
  },
  {
    name: beslisboomJLRn4nd5y9Meta?.name ?? "intake-id-beslisboom",
    path: beslisboomJLRn4nd5y9Meta?.path ?? "/intake/:id()/beslisboom",
    meta: beslisboomJLRn4nd5y9Meta || {},
    alias: beslisboomJLRn4nd5y9Meta?.alias || [],
    redirect: beslisboomJLRn4nd5y9Meta?.redirect || undefined,
    component: () => import("/shared/home/frontend/deployr/releases/20250507100418/packages/layers/intake/pages/intake/[id]/beslisboom.vue").then(m => m.default || m)
  },
  {
    name: dashboardx3xF8IcrQcMeta?.name ?? "intake-id-dashboard",
    path: dashboardx3xF8IcrQcMeta?.path ?? "/intake/:id()/dashboard",
    meta: dashboardx3xF8IcrQcMeta || {},
    alias: dashboardx3xF8IcrQcMeta?.alias || [],
    redirect: dashboardx3xF8IcrQcMeta?.redirect || undefined,
    component: () => import("/shared/home/frontend/deployr/releases/20250507100418/packages/layers/intake/pages/intake/[id]/dashboard.vue").then(m => m.default || m)
  },
  {
    name: financieringoafurj7jIkMeta?.name ?? "intake-id-financiering",
    path: financieringoafurj7jIkMeta?.path ?? "/intake/:id()/financiering",
    meta: financieringoafurj7jIkMeta || {},
    alias: financieringoafurj7jIkMeta?.alias || [],
    redirect: financieringoafurj7jIkMeta?.redirect || undefined,
    component: () => import("/shared/home/frontend/deployr/releases/20250507100418/packages/layers/intake/pages/intake/[id]/financiering.vue").then(m => m.default || m)
  },
  {
    name: geldnemerstjU2dwGtpvMeta?.name ?? "intake-id-geldnemers",
    path: geldnemerstjU2dwGtpvMeta?.path ?? "/intake/:id()/geldnemers",
    meta: geldnemerstjU2dwGtpvMeta || {},
    alias: geldnemerstjU2dwGtpvMeta?.alias || [],
    redirect: geldnemerstjU2dwGtpvMeta?.redirect || undefined,
    component: () => import("/shared/home/frontend/deployr/releases/20250507100418/packages/layers/intake/pages/intake/[id]/geldnemers.vue").then(m => m.default || m)
  },
  {
    name: identificatieZoOokJOUpeMeta?.name ?? "intake-id-identificatie",
    path: identificatieZoOokJOUpeMeta?.path ?? "/intake/:id()/identificatie",
    meta: identificatieZoOokJOUpeMeta || {},
    alias: identificatieZoOokJOUpeMeta?.alias || [],
    redirect: identificatieZoOokJOUpeMeta?.redirect || undefined,
    component: () => import("/shared/home/frontend/deployr/releases/20250507100418/packages/layers/intake/pages/intake/[id]/identificatie.vue").then(m => m.default || m)
  },
  {
    name: indexVJWnDeYWowMeta?.name ?? "intake-id",
    path: indexVJWnDeYWowMeta?.path ?? "/intake/:id()",
    meta: indexVJWnDeYWowMeta || {},
    alias: indexVJWnDeYWowMeta?.alias || [],
    redirect: indexVJWnDeYWowMeta?.redirect || undefined,
    component: () => import("/shared/home/frontend/deployr/releases/20250507100418/packages/layers/intake/pages/intake/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: object8u8DVIbivoMeta?.name ?? "intake-id-object",
    path: object8u8DVIbivoMeta?.path ?? "/intake/:id()/object",
    meta: object8u8DVIbivoMeta || {},
    alias: object8u8DVIbivoMeta?.alias || [],
    redirect: object8u8DVIbivoMeta?.redirect || undefined,
    component: () => import("/shared/home/frontend/deployr/releases/20250507100418/packages/layers/intake/pages/intake/[id]/object.vue").then(m => m.default || m)
  },
  {
    name: ondertekenenxM6Y54YxMiMeta?.name ?? "intake-id-ondertekenen",
    path: ondertekenenxM6Y54YxMiMeta?.path ?? "/intake/:id()/ondertekenen",
    meta: ondertekenenxM6Y54YxMiMeta || {},
    alias: ondertekenenxM6Y54YxMiMeta?.alias || [],
    redirect: ondertekenenxM6Y54YxMiMeta?.redirect || undefined,
    component: () => import("/shared/home/frontend/deployr/releases/20250507100418/packages/layers/intake/pages/intake/[id]/ondertekenen.vue").then(m => m.default || m)
  },
  {
    name: overigRNjh9o0wf3Meta?.name ?? "intake-id-overig",
    path: overigRNjh9o0wf3Meta?.path ?? "/intake/:id()/overig",
    meta: overigRNjh9o0wf3Meta || {},
    alias: overigRNjh9o0wf3Meta?.alias || [],
    redirect: overigRNjh9o0wf3Meta?.redirect || undefined,
    component: () => import("/shared/home/frontend/deployr/releases/20250507100418/packages/layers/intake/pages/intake/[id]/overig.vue").then(m => m.default || m)
  },
  {
    name: verklaringenRLZPjGZLOeMeta?.name ?? "intake-id-verklaringen",
    path: verklaringenRLZPjGZLOeMeta?.path ?? "/intake/:id()/verklaringen",
    meta: verklaringenRLZPjGZLOeMeta || {},
    alias: verklaringenRLZPjGZLOeMeta?.alias || [],
    redirect: verklaringenRLZPjGZLOeMeta?.redirect || undefined,
    component: () => import("/shared/home/frontend/deployr/releases/20250507100418/packages/layers/intake/pages/intake/[id]/verklaringen.vue").then(m => m.default || m)
  }
]